import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { getLocalStorage } from 'helpers/storage';

import Button from 'components/commons/Button';

import './ShippingQuote.scss';

const ShippingQuote = (props) => {
  const { onSubmit, quote, zipCode, loading, showQuote = true } = props;
  const [inputValue, setInputValue] = useState('');

  useEffect(() => {
    const savedZipCode = getLocalStorage('lenceria-shipping-zip-code');
    if (savedZipCode) {
      setInputValue(savedZipCode);
      onSubmit(savedZipCode);
    }
  }, []);

  const onKeyDown = (event) => {
    if (event.key === 'Enter' && !!inputValue.trim()) {
      event.preventDefault();
      onSubmit(inputValue.trim());
    }
  };

  return (
    <div className="shipping-quote-container">
      {zipCode ? (
        <>
          <div className="shipping-quote-title">
            Código postal: <strong>{zipCode}</strong>
            <Button
              buttonClass="shipping-quote-button"
              text="Cambiar"
              type="button"
              onClick={() => onSubmit('')}
            />
          </div>
          {quote && showQuote && (
            <div className="shipping-quote-title">
              Precio del envío: <strong>${quote.price.toFixed(2)}</strong>
            </div>
          )}
        </>
      ) : (
        <div className="shipping-quote-title">
          Medios de envío
        </div>
      )}
      {!zipCode && (
        <>
          <div className="shipping-quote-input-container">
            <input
              id="shipping-quote-input"
              placeholder="Ingresar código postal"
              value={inputValue}
              onChange={(event) => setInputValue(event.target.value)}
              className="form-control shipping-quote-input"
              onKeyDown={onKeyDown}
            />
            <Button
              buttonClass="shipping-quote-button"
              disabled={!inputValue.trim() || loading}
              text={loading ? 'Calculando...' : 'Calcular'}
              type="button"
              onClick={() => onSubmit(inputValue.trim())}
            />
          </div>
          <a className="shipping-quote-link" href="https://www.correoargentino.com.ar/formularios/cpa" target="_blank" rel="noopener noreferrer">
            No sé mi código postal
          </a>
        </>
      )}
    </div>
  );
};

ShippingQuote.defaultProps = {
  quote: null,
  zipCode: '',
  loading: false,
  showQuote: true,
};

ShippingQuote.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  quote: PropTypes.object,
  zipCode: PropTypes.string,
  loading: PropTypes.bool.isRequired,
  showQuote: PropTypes.bool,
};

export default ShippingQuote;
